var map = {
	"./pdf": 48,
	"./pdf.js": 48,
	"./pdf.js.map": 6421,
	"./pdf.min": 304,
	"./pdf.min.js": 304,
	"./pdf.worker": 62,
	"./pdf.worker.entry": 305,
	"./pdf.worker.entry.js": 305,
	"./pdf.worker.js": 62,
	"./pdf.worker.js.map": 6422,
	"./pdf.worker.min": 306,
	"./pdf.worker.min.js": 306
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;



//////////////////
// WEBPACK FOOTER
// ./~/pdfjs-dist/build ^\.\/.*$
// module id = 81
// module chunks = 0